<template>
  <div class="d-copy-cals text-dark">
    <div class="d-acc" :class="{'d-acc--open': isAccOpen}">
      <div class="d-acc__header" @click="toggleIsAccOpen">
        <div class="d-acc__header__left">
          <div class="d-toggle-arrow" :class="{'d-toggle-arrow--open': isAccOpen}"></div>
          <h3>{{ title }} ({{ calendarsExclArchivedWithoutFilters.length }})</h3>
        </div>
      </div>
      <ul class="d-copy-cals__list" v-if="isAccOpen">
        <li class="select-all-item d-copy-cals__list__header select-all-item d-copy-cals__list__header__filters" v-if="calType === 'user'">
          <TaggingFilter
            :schoolid="schoolId"
            :showHowMany="false"
            :tags="tags"
            :selectedTags="appliedFilters"
            @set="setTagFromFilter"
            @remove="removeTagFromFilter"
          >
          </TaggingFilter>
        </li>
        <li class="select-all-item d-copy-cals__list__header">
          <p class="d-acc__header__select-all" @click="toggleAllKlasses">
            <span v-if="selectedCalIds.length < 1">{{ $t('vue2.tagging.select_all') }}</span>
            <span v-else>{{ $t('vue2.tagging.unselect_all') }}</span>
          </p>
          <div class="d-copy-cals__list__header__right">
            <p>{{ selectedCalIds.length }} {{ $t('vue2.calendars.selected_of') }} {{ calendarsExclArchived.length }}</p>
            <button class="bttn--disabled hint--bottom-left"
                    :aria-label="this.$t('vue2.calendars.select_calendars_to_copy')"
                    v-if="selectedCalIds.length < 1">{{ $t('vue2.calendars.copy') }}
            </button>
            <CopyButton v-else
                        :calType="calType"
                        @open="isCopyOpen = true"
                        @close="isCopyOpen = false"
                        @submit="copyCals($event)">
            </CopyButton>
          </div>
        </li>
        <li class="d-copy-cals__cal"
            v-for="calendar in calendarsExclArchived" :key="calendar.id"
            @click="toogleCal(calendar.id)"
            :class="{'d-copy-cals__cal--selected': getIsInSelectedCalIds(calendar.id)}">
          <div class="d-copy-cals__cal__selector">
            <div class="checkbox"></div>
          </div>
          {{ calendar.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import CopyButton from './CopyMultipleCalendarsCopy'
import eventbus from '../../eventbus'
import docendo from '../../docendo'
import TaggingFilter from '../Tagging/TaggingFilter.vue'

export default {
  components: {TaggingFilter, CopyButton},
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    calType: {
      type: String,
      default: 'klass'
    },
    calendars: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      copyCalType: null,
      selectedCalIds: [],
      selectedWeeks: ['2021-26'],
      copyDate: '2021-02-08', // week 6,
      isDeleteEvents: true,
      isAccOpen: false,
      isArchivedAccOpen: false,
      isCopyOpen: false,
      appliedFilters: [],
      tags: []
    }
  },
  computed: {
    schoolId () {
      return this.$store.getters.schoolId
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    filteredCalendars () {
      if (this.appliedFilters.length < 1) {
        return this.calendars
      }
      return this.calendars.filter(calendar => calendar.user_tags.some(tag => this.appliedFilters.includes(tag)))
    },
    calendarsExclArchived () {
      return this.filteredCalendars.filter(calendar => !calendar.archived_at)
    },
    calendarsExclArchivedWithoutFilters () {
      return this.calendars.filter(calendar => !calendar.archived_at)
    },
    archivedCalendars () {
      return this.filteredCalendars.filter(calendar => calendar.archived_at)
    },
    title () {
      switch (this.calType) {
        case 'klass':
          return this.$t('vue2.common.classes')
        case 'user':
          return this.$t('vue2.common.users')
        case 'room':
          return this.$t('vue2.common.rooms')
        case 'merge':
          return this.$t('vue2.common.merge_calendars')
        case 'other':
          return this.$t('vue2.common.other_calendars')
      }
    }
  },
  methods: {
    setTagFromFilter (tag) {
      this.selectedCalIds = []
      this.appliedFilters.push(tag)
    },
    removeTagFromFilter (tag) {
      this.appliedFilters.splice(this.appliedFilters.indexOf(tag), 1)
    },
    getIsInSelectedCalIds (calId) {
      return this.selectedCalIds.indexOf(calId) > -1
    },
    toogleCal (calId) {
      let idx = this.selectedCalIds.indexOf(calId)
      if (idx < 0) {
        this.selectedCalIds.push(calId)
      } else {
        this.selectedCalIds.splice(idx, 1)
      }
    },
    toggleAllKlasses () {
      if (this.selectedCalIds.length > 0) {
        this.selectedCalIds = []
      } else {
        this.selectedCalIds = []
        this.filteredCalendars.forEach(calendar => this.selectedCalIds.push(calendar.id))
      }
    },
    copyCals (objWeeks) {
      this.copyDate = objWeeks.copyDate
      this.selectedWeeks = objWeeks.selectedWeeks
      this.isDeleteEvents = objWeeks.isDeleteEvents
      this.copyWeeks()
    },
    copyWeeks (calId) {
      if (this.selectedCalIds.length < 1) {
        return
      }
      docendo.calendarCopyWeeks(this.selectedCalIds, this.copyDate, this.selectedWeeks, this.isDeleteEvents, [], ['absence', 'presence', 'activity'], data => {
        eventbus.toast = {text: 'Kopierer kalendere', success: true}
        this.selectedCalIds = []
      })
    },
    toggleIsAccOpen () {
      if (this.isCopyOpen) {
        return
      }
      if (!this.isAccOpen) {
        this.isAccOpen = true
      } else {
        this.isAccOpen = false
        this.selectedCalIds = []
      }
    },
    getTags () {
      docendo.schoolTags(this.schoolId, data => {
        this.tags = data
      })
    }
  },
  mounted () {
    if (this.isOpen) {
      this.isAccOpen = true
    }
    if (this.calType === 'user') {
      this.getTags()
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-acc {
  background: #ffffff;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.d-acc ul {
  border: 1px solid #d8d8d8;
  border-top: none;
  border-radius: 0 0 4px 4px;
  margin: 0;
}

.d-acc ul li {
  user-select: none;
}

.d-acc__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  border: 1px solid #d8d8d8;
  padding: 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: border-color 0.25s;
}

.d-acc:not(.d-acc--open) .d-acc__header:hover {
  border-color: var(--blue);
}

.d-acc--open .d-acc__header {
  border-radius: 4px 4px 0 0;
}

.d-acc__header__left {
  display: flex;
  align-items: center;
}

.d-acc__header__select-all {
  cursor: pointer;
}

.d-acc__header__select-all:hover {
  text-decoration: underline;
}

.d-copy-cals__list li:nth-child(odd) {
  background: #f8fafb;
}

.d-copy-cals__cal {
  padding: 0.25rem 1rem;
  display: flex;
  align-items: center;
  border-top: 1px solid transparent;
  cursor: pointer;
}

.d-copy-cals__list li.d-copy-cals__cal.d-copy-cals__cal--selected {
  border-top: 1px solid #fff;
  background-color: rgba(77, 138, 207, .3);
}

.d-copy-cals__list__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;
}

.d-copy-cals__list li.d-copy-cals__cal:hover {
  color: var(--blue);
}

.d-copy-cals__cal__selector {
  width: 80px;
  padding-left: 20px;
  cursor: pointer;
  position: relative;
  display: inline-block;
  height: 25px;
  line-height: 25px;
  font-size: 1rem;
  user-select: none;
}

.checkbox {
  position: absolute;
  top: 0;
  left: 20px;
  width: 18px;
  height: 18px;
  z-index: 0;
  border: 2px solid #5a5a5a;
  border-radius: 1px;
  margin-top: 3px;
  transition: .2s;
}

.d-copy-cals__cal--selected .checkbox {
  top: -4px;
  left: 15px;
  width: 12px;
  height: 22px;
  border-top: 2px solid transparent;
  border-left: 2px solid transparent;
  border-right: 2px solid #26a69a;
  border-bottom: 2px solid #26a69a;
  transform: rotate(40deg);
  backface-visibility: hidden;
  transform-origin: 100% 100%;
}

.d-acc__header__select-all {
  font-size: 1rem;
  width: 80px;
}

.select-all-item {
  padding: 10px 20px;
}

.d-copy-cals__list__header__right {
  display: flex;
  align-items: center;
}

.d-copy-cals__list__header__right > p {
  margin-right: 1rem;
}

.d-toggle-arrow {
  width: 7px;
  height: 7px;
  border: 2px solid var(--dark-blue);
  border-width: 2px 2px 0 0;
  transform: rotate(45deg);
  margin-right: 1rem;
  transition: transform 0.25s;
}

.d-toggle-arrow.d-toggle-arrow--open {
  transform: rotate(135deg);
}

.archived-cals-toggler {
  display: flex;
  align-items: center;
  padding: 1rem 3rem;
  font-weight: bold;
  cursor: pointer;
}

.archived-cals-toggler:hover {
  color: var(--blue);
}

.archived-cal {
  padding: 0.25rem 1rem;
  padding-left: 92px;
}

.bttn--small {
  margin-left: 1rem;
  font-size: 0.9rem;
}

</style>



// WEBPACK FOOTER //
// CopyMultipleCalendars.vue?73aa5204